// extracted by mini-css-extract-plugin
module.exports = {"image":"AboutPage_image__29lsZ","imageWrapper":"AboutPage_imageWrapper__2DUbc"};